export const imageUrlDomain = 'https://imandiao.oss-cn-beijing.aliyuncs.com/website/'// 如果更改域名，针对背景图片需要做单独的处理
